export const focusScopeChangeEventType = 'focus-scope-change';
export class FocusScopeChangeEvent extends Event {
    constructor(oldState, newState) {
        super(focusScopeChangeEventType);
        this.newState = newState;
        this.oldState = oldState;
    }
}
//# sourceMappingURL=focus-scope-event.js.map